<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div id="data-list-list-view"  class="vx-row lg:w-4/4 w-full">
    <vs-prompt
            :title="$t('NewArea')"
            :accept-text="$t('Save')"
            :cancel-text="$t('Cancel')"
            @cancel="clearAreaModal"
            @accept="SaveArea"
            @close="clearAreaModal"
            :is-valid="validateAreaForm"
            :active.sync="activePromptArea">
                <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent style="min-height:200px;max-height:75vh" >
                       <label for="Area" class="vs-input--label">Area</label>
                                  <v-select
                                    label="Name"
                                    class="w-full"
                                    v-model="area.CourseAreaOfStudy"
                                    :options="areas"
                                    :reduce="Area => Area"
                                  />
                            <!-- <vs-select class="mt-5 w-full" label="Area" v-model="area.CourseAreaOfStudy">
                              <vs-select-item :key="index" :value="item" :text="item.Name" v-for="(item,index) in areas" />
                            </vs-select> -->
                    </form>
                </VuePerfectScrollbar>
          </vs-prompt>

          <vs-prompt
            :title="$t('NewSector')"
            :accept-text="$t('Save')"
            :cancel-text="$t('Cancel')"
            @cancel="clearSectorModal"
            @accept="SaveSector"
            @close="clearSectorModal"
            :is-valid="validateSectorForm"
            :active.sync="activePromptSector">
                <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl" >
                    <form @submit.prevent style="min-height:200px;max-height:75vh">
                       <label for="Sector" class="vs-input--label">Sector</label>
                                  <v-select
                                    label="Name"
                                    class="w-full"
                                    v-model="sector.IndustrySector"
                                    :options="industrySectors"
                                    :reduce="Sector => Sector"
                                  />
                       <!-- <vs-select class="mt-5 w-full" label="Sector" v-model="sector.IndustrySector">
                        <vs-select-item :key="index" :value="item" :text="item.Name" v-for="(item,index) in industrySectors" />
                      </vs-select> -->
                    </form>
                </VuePerfectScrollbar>
          </vs-prompt>
<div class=" lg:w-1/2 " style="padding-right:20px">
      <vx-card :title="$t('WorkArea')" class="mb-base" >
         <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus" @click="activePromptArea=true">{{$t('AddArea')}}</vs-button>

          <vs-table ref="table"   pagination :max-items="5"  :data="getListOfworkArea" >
            <template slot="thead">
              <vs-th >{{$t('Work')}} </vs-th>
              <vs-th>{{$t('Action')}}</vs-th>
            </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                       <p class="product-name font-medium truncate">{{ tr.CourseAreaOfStudy.Name }}</p>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editArea(tr)" />
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="openConfirmForArea(tr)"  />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
          </vs-table>
      </vx-card>
</div>
<div class=" lg:w-1/2">
       <vx-card :title="$t('InstructorIndustrySector')" class="mb-base" >
        <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus" @click="activePromptSector=true">{{$t('AddSector')}}</vs-button>

          <vs-table ref="table"   pagination :max-items="5"  :data="getListOfIndustrySector" >
            <template slot="thead">
              <vs-th >{{$t('IndustrySector')}}</vs-th>
              <vs-th>{{$t('Action')}}</vs-th>
            </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                       <p class="product-name font-medium truncate">{{ tr.IndustrySector.Name }}</p>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editSector(tr)" />
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="openConfirmForSector(tr)" />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
          </vs-table>
      </vx-card>
</div>
</div>

</template>


<script>
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleCourseAreaOfStudy from "@/store/settings/courseAreaOfStudy/moduleCourseAreaOfStudy.js";
import moduleIndustrySector from "@/store/settings/industrySector/moduleIndustrySector.js";
export default {
  components:{
     vSelect,
     VuePerfectScrollbar
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
       activePromptArea:false,
       activePromptSector:false,
      instructorModel: this.data,
       settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      course:{},
      area:{},
      sector :{},
      dataForDeleted:{},
      edit:false,
      listOfInstructorWorkArea:[],
      listOfInstructorIndustrySector:[],
    }
  },
  computed: {
    validateAreaForm() {
      return this.area.CourseAreaOfStudy!=undefined
    },
     validateSectorForm() {
      return this.sector.IndustrySector!=undefined
    },
    getListOfworkArea(){
      return this.listOfInstructorWorkArea
    },
     getListOfIndustrySector(){
      return this.listOfInstructorIndustrySector
    },
    areas() {
      debugger;
      return this.$store.state.courseAreaOfStudyList.courseAreaOfStudies;
    },
    industrySectors() {
      return this.$store.state.industrySectorList.industrySectors;
    },
  },
  methods: {
    SaveArea()
    {
      debugger;
        const isExist = this.instructorModel.InstructorAreas.findIndex((p) => p.CourseAreaOfStudyID == this.area.CourseAreaOfStudy.ID);

       if(isExist>=0)
        {
         // this.colorAlert = color
            this.$vs.dialog({
                color: "warning",
                title:this.$t("Dialogwarning") ,
               text: this.$t("ThisareaAlreadyExists"),


            })
           this.area={};
            return;
        }
        if(this.edit)
          {
              this.deleteArea(this.dataForDeleted);
              this.edit=false;
          }
          this.area.CourseAreaOfStudyID=this.area.CourseAreaOfStudy.ID;
          //this.deleteCourse(this.course);
          this.listOfInstructorWorkArea.push(this.area);
           this.instructorModel.InstructorAreas= this.listOfInstructorWorkArea;
          //this.deletefacility(this.facility);
         // this.$store.commit("classRoomList/ADD_Facility", this.facility);
          this.clearAreaModal();

    },
 SaveSector()
    {
      debugger;
        const isExist = this.instructorModel.InstructorIndustrySectors.findIndex((p) => p.IndustrySectorID == this.sector.IndustrySector.ID);

    if(isExist>=0)
        {
         // this.colorAlert = color
            this.$vs.dialog({
                color: "warning",
                title:this.$t("Dialogwarning"),
                 text: this.$t("ThissectorAlreadyExists"),

            })
           this.clearSectorModal();
            return;
        }
        if(this.edit)
          {
              this.deleteSector(this.dataForDeleted);
              this.edit=false;
          }
          this.sector.IndustrySectorID=this.sector.IndustrySector.ID;
          //this.deleteCourse(this.course);
          this.listOfInstructorIndustrySector.push(this.sector);
           this.instructorModel.InstructorIndustrySectors= this.listOfInstructorIndustrySector;
          //this.deletefacility(this.facility);
         // this.$store.commit("classRoomList/ADD_Facility", this.facility);
       this.clearSectorModal();

    },
    acceptAlertForArea() {
      this.deleteArea(this.rowDataForDelete);
      this.$vs.notify({
        color: "danger",
        title: this.$t("Deletedrecord"),
          text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    acceptAlertForSector() {
      this.deleteSector(this.rowDataForDelete);
      this.$vs.notify({
        color: "danger",
        title:  this.$t("Deletedrecord"),
          text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    deleteArea(data) {
       debugger;
      if(data.ID>0)
      {
         this.$store.dispatch("instructorList/removeArea",  data.ID);
      }
    const ItemIndex = this.instructorModel.InstructorAreas.findIndex((p) => p.CourseAreaOfStudyID == data.CourseAreaOfStudyID)
     // if(ItemIndex!=-1)
          this.instructorModel.InstructorAreas.splice(ItemIndex, 1)

    },
    deleteSector(data) {
       debugger;
      if(data.ID>0)
      {
         this.$store.dispatch("instructorList/removeSector",  data.ID);
      }
    const ItemIndex = this.instructorModel.InstructorIndustrySectors.findIndex((p) => p.IndustrySectorID == data.IndustrySectorID)
     // if(ItemIndex!=-1)
          this.instructorModel.InstructorIndustrySectors.splice(ItemIndex, 1)

    },
    editArea(data){
      this.edit =true;
       this.area = JSON.parse(JSON.stringify(data));
       this.dataForDeleted=this.area;
       this.activePromptArea=true;

    },

    editSector(data){
      this.edit =true;
       this.sector = JSON.parse(JSON.stringify(data));
       this.dataForDeleted=this.sector;
       this.activePromptSector=true;

    },
     clearAreaModal() {
      this.area = {};
    },

     clearSectorModal() {
      this.sector={};
      return;
    },

    openConfirmForArea(data) {
      debugger;
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title:  this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlertForArea
      });
    },
     openConfirmForSector(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlertForSector
      });
    },
  },
  created(){
    debugger;
     if (!moduleCourseAreaOfStudy.isRegistered) {
      this.$store.registerModule("courseAreaOfStudyList", moduleCourseAreaOfStudy);
      moduleCourseAreaOfStudy.isRegistered = true;
    }
    this.$store.dispatch("courseAreaOfStudyList/fetchDataListItems");
    if(this.instructorModel.InstructorAreas.length>0)
    {
     this.listOfInstructorWorkArea= this.instructorModel.InstructorAreas;
    }
    if(this.instructorModel.InstructorIndustrySectors.length>0)
    {
     this.listOfInstructorIndustrySector= this.instructorModel.InstructorIndustrySectors;
    }
      if (!moduleIndustrySector.isRegistered) {
      this.$store.registerModule("industrySectorList", moduleIndustrySector);
      moduleIndustrySector.isRegistered = true;
    }
    this.$store.dispatch("industrySectorList/fetchDataListItems");
  }
}
</script>
